module.exports = __webpack_public_path__ + "static/media/pet-gender-final.19ef9e1b.svg";